import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityHoliday } from "../../entity/EntityHoliday";

export class DtoHolidaysPutReq extends EntityHoliday {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_holiday_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
